import React, { Component } from 'react';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import get from 'lodash/get';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Confirm from 'react-confirm-bootstrap';
import { PublisherApi } from '../../../api';
import CNameFormModal from '../../../components/publisher/cnames/CNameForm';
import CNamePopup from '../../../components/publisher/cnames/CNamePopup';
import { ButtonDelete, ButtonShow } from '../../../components/common/buttons/actions';
import { ButtonAdd } from '../../../components/common/buttons';

class CNamesIndex extends Component {

  componentDidMount() {
    this.fetchCnames();
  }

  fetchCnames(params = {}) {
    const { dispatch } = this.props;
    dispatch(PublisherApi.actions.cnames(params));
  }

  newResource() {
    const { dispatch } = this.props;
    dispatch(show('CnameFormModal', {
      heading: 'New CNAME',
      formAction: 'Create'
    }));
  }

  handleDelete(c) {
    const { dispatch } = this.props;
    dispatch(PublisherApi.actions.cnameDelete.post(c, (error, success) => {
      if (success) {
        this.fetchCnames();
        dispatch(PublisherApi.actions.websites());
      }
    }));
  }

  handleInstruct(c, r) {
    const { dispatch } = this.props;
    dispatch(show('CnamePopModal', { cname: r }));
  }

  handleOnPageChange(page, per_page) {
    this.fetchCnames({
      page,
      per_page
    });
  }

  renderActions(c, r) {
    return (
      <ul className='list-inline'>
        <li>
          <ButtonShow
            btnLabel='Setup Info'
            onClick={this.handleInstruct.bind(this, c, r)}
          />
        </li>
        <li>
          <Confirm
            onConfirm={this.handleDelete.bind(this, c)}
            body='Are you sure you want to delete this?'
            confirmText='Confirm Delete'
            title={`Deleting CNAME - ${r.domain}`}
          >
            <div><ButtonDelete /></div>
          </Confirm>
        </li>
      </ul>
    );
  }

  render() {
    const { cnames } = this.props;
    const { data, meta } = cnames || {};
    const { pagination } = meta || {};
    const totalCount = get(pagination, 'total_count', null);
    const options = {
      sizePerPage: get(pagination, 'per_page', 10),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1)
    };
    const fetchInfo = {
      dataTotalSize: totalCount || 1
    };
    return (
      <div className='wrapper wrapper-content'>
        <div className='ibox'>
          <div className='ibox-title'>
            <h5>CNAMEs</h5>
          </div>
          <div className='ibox-content'>
            <div className='m-b-sm text-left'>
              <ButtonAdd
                onClick={this.newResource.bind(this)}
                btnLabel='Add CNAME'
              />

            </div>
            <BootstrapTable
              striped
              remote
              ref='CnamesTable'
              data={data || []}
              pagination
              fetchInfo={fetchInfo}
              options={options}
            >
              <TableHeaderColumn
                width="200"
                dataField="domain"
                dataFormat={(c) => c}
              >
                Domain
              </TableHeaderColumn>

              <TableHeaderColumn
                width="200"
                dataField="domain"
                dataFormat={(_c, r) => `jdx.${r.domain}`}
              >
                Alias / Host / Name
              </TableHeaderColumn>

              <TableHeaderColumn
                width="200"
                dataField="domain"
                dataFormat={(c, r) => `${r.uuid}.jobadx.com`}
              >
                Destination / Points To / Value
              </TableHeaderColumn>

              <TableHeaderColumn
                width="150"
                dataField="status"
                dataFormat={(c) => c}
              >
                Status
              </TableHeaderColumn>

              <TableHeaderColumn
                isKey
                width="250"
                dataField="uuid"
                dataFormat={this.renderActions.bind(this)}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
            <CNameFormModal />
            <CNamePopup />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { publisher } = state;
  return { cnames: publisher.cnames.data, isLoading: publisher.cnames.loading };
};

export default connect(mapStateToProps)(CNamesIndex);
